import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localePTBR from '@angular/common/locales/pt';
import {
  APP_INITIALIZER,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { jqxBarGaugeComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxbargauge';
import { jqxSchedulerComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxscheduler';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { ChartsModule } from 'ng2-charts';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { EnvService } from 'src/app/_servicos/env.service';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LazyImgDirective } from './_diretivas/lazy-img.directive';
import { MaterialElevationDirective } from './_diretivas/material-elevation.directive';
import { initializerKeyCloak } from './_guardas/auth-init';
import { CapitalizePipe } from './_pipes/capitalize.pipe';
import { CepPipe } from './_pipes/cep.pipe';
import { DataStrPipe } from './_pipes/data-str.pipe';
import { DocCpfPipe } from './_pipes/doc-cpf.pipe';
import { DocPisPipe } from './_pipes/doc-pis.pipe';
import { DocRgPipe } from './_pipes/doc-rg.pipe';
import { DocTituloEleitorPipe } from './_pipes/doc-titulo-eleitor.pipe';
import { TelefonePipe } from './_pipes/telefone.pipe';
import { EnvServiceProvider } from './_servicos/env.service.provider';
import { InterceptorService } from './_servicos/loader/interceptor.service';
import { AfastamentoOutrosComponent } from './afastamento-outros/afastamento-outros.component';
import { AfastamentoSetorComponent } from './afastamento-setor/afastamento-setor.component';
import { AfastamentoComponent } from './afastamento/afastamento.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AusenciaFaltaComponent } from './ausencia-falta/ausencia-falta.component';
import { AvaliacaoGaugeComponent } from './avaliacao-gauge/avaliacao-gauge.component';
import { AvaliacaoComponent } from './avaliacao/avaliacao.component';
import { BancoHorasComponent } from './banco-horas/banco-horas.component';
import { BeneficioComponent } from './beneficio/beneficio.component';
import { getBrasilPaginatorIntl } from './brasil-paginator-intl';
import { CaixaEntradaEmailComponent } from './caixa-entrada-email/caixa-entrada-email.component';
import { CardPerfilComponent } from './card-perfil/card-perfil.component';
import { ComissaoComponent } from './comissao/comissao.component';
import { ComprovanteRendimentoComponent } from './comprovante-rendimento/comprovante-rendimento.component';
import { ConfiguracoesComponent } from './configuracoes/configuracoes.component';
import { ConsignadoComponent } from './consignado/consignado.component';
import { ContaPessoalComponent } from './conta-pessoal/conta-pessoal.component';
import { CurriculoComponent } from './curriculo/curriculo.component';
import { DadosFuncionaisComponent } from './dados-funcionais/dados-funcionais.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { DependenteComponent } from './dependente/dependente.component';
import { DiariaComponent } from './diaria/diaria.component';
import { ElogioComponent } from './elogio/elogio.component';
import { EnderecoEmailComponent } from './endereco-email/endereco-email.component';
import { EvolucaoCarreiraComponent } from './evolucao-carreira/evolucao-carreira.component';
import { PublicacoesExternasComponent } from './extras/publicacoes-externas/publicacoes-externas.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeriadoComponent } from './feriado/feriado.component';
import { FeriasComponent } from './ferias/ferias.component';
import { FrequenciaComponent } from './frequencia/frequencia.component';
import { GaugeComponent } from './gauge/gauge.component';
import { HoleriteComponent } from './holerite/holerite.component';
import { InicioComponent } from './inicio/inicio.component';
import { LicencaComponent } from './licenca/licenca.component';
import { LotacaoComponent } from './lotacao/lotacao.component';
import { MeEncontreComponent } from './me-encontre/me-encontre.component';
import { MenuComponent } from './menu/menu.component';
import { ModalMensagemBancoComponent } from './modal-mensagem-banco/modal-mensagem-banco.component';
import { NaoAutenticadoComponent } from './nao-autenticado/nao-autenticado.component';
import { NotificacaoMostrarComponent } from './notificacao-mostrar/notificacao-mostrar.component';
import { NotificacaoComponent } from './notificacao/notificacao.component';
import { NovoSchedulerComponent } from './novo-scheduler/novo-scheduler.component';
import { OperadoraSemAnsComponent } from './operadora-sem-ans/operadora-sem-ans.component';
import { PainelAjudaModule } from './painel-ajuda/painel-ajuda.module';
import { PessoaDocumentoComponent } from './pessoa-documento/pessoa-documento.component';
import { PontoFrequenciaComponent } from './ponto-frequencia/ponto-frequencia.component';
import { ProadComponent } from './proad/proad.component';
import { RamalServidorComponent } from './ramal-servidor/ramal-servidor.component';
import { RatingComponent } from './rating/rating.component';
import { Ratting2Component } from './ratting2/ratting2.component';
import { RecadastramentoComponent } from './recadastramento/recadastramento.component';
import { RecursoEstatisticaComponent } from './recurso-estatistica/recurso-estatistica.component';
import { SairComponent } from './sair/sair.component';
import { ServidorInativoComponent } from './servidor-inativo/servidor-inativo.component';
import { SgrhCreditoDiaComponent } from './sgrh-credito-dia/sgrh-credito-dia.component';
import { SgrhCreditoHoraComponent } from './sgrh-credito-hora/sgrh-credito-hora.component';
import { SgrhCreditoComponent } from './sgrh-credito/sgrh-credito.component';
import { SharedModule } from './shared/share.module';
import { SistemasComponent } from './sistemas/sistemas.component';
import { SituacaoEleitoralComponent } from './situacao-eleitoral/situacao-eleitoral.component';
import { SuspensaoComponent } from './suspensao/suspensao.component';
import { TabelaComponent } from './tabela/tabela.component';
import { TempoServicoComponent } from './tempo-servico/tempo-servico.component';
import { UsuarioConectadoComponent } from './usuario-conectado/usuario-conectado.component';
import { WhatsappSolicitacaoCadastroComponent } from './whatsapp-solicitacao-cadastro/whatsapp-solicitacao-cadastro.component';

registerLocaleData(localePTBR);

const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    UsuarioConectadoComponent,
    CardPerfilComponent,
    NaoAutenticadoComponent,
    InicioComponent,
    SairComponent,
    TabelaComponent,
    RatingComponent,
    LicencaComponent,
    HoleriteComponent,
    DiariaComponent,
    SituacaoEleitoralComponent,
    AvaliacaoComponent,
    DependenteComponent,
    ServidorInativoComponent,
    ContaPessoalComponent,
    AfastamentoComponent,
    jqxSchedulerComponent,
    GaugeComponent,
    MaterialElevationDirective,
    jqxBarGaugeComponent,
    NovoSchedulerComponent,
    BancoHorasComponent,
    BeneficioComponent,
    ComprovanteRendimentoComponent,
    DadosPessoaisComponent,
    ComissaoComponent,
    ElogioComponent,
    CurriculoComponent,
    ConsignadoComponent,
    EvolucaoCarreiraComponent,
    LotacaoComponent,
    AvaliacaoGaugeComponent,
    DadosFuncionaisComponent,
    CepPipe,
    PessoaDocumentoComponent,
    PontoFrequenciaComponent,
    DocCpfPipe,
    DocRgPipe,
    DocPisPipe,
    DocTituloEleitorPipe,
    DataStrPipe,
    Ratting2Component,
    FeriasComponent,
    SuspensaoComponent,
    AusenciaFaltaComponent,
    AfastamentoOutrosComponent,
    RamalServidorComponent,
    MeEncontreComponent,
    TelefonePipe,
    AfastamentoSetorComponent,
    ProadComponent,
    RecursoEstatisticaComponent,
    SgrhCreditoComponent,
    SgrhCreditoDiaComponent,
    SgrhCreditoHoraComponent,
    FeriadoComponent,
    FeedbackComponent,
    EnderecoEmailComponent,
    FrequenciaComponent,
    CaixaEntradaEmailComponent,
    TempoServicoComponent,
    ModalMensagemBancoComponent,
    OperadoraSemAnsComponent,
    CapitalizePipe,
    PublicacoesExternasComponent,
    SistemasComponent,
    RecadastramentoComponent,
    LazyImgDirective,
    WhatsappSolicitacaoCadastroComponent,
    NotificacaoComponent,
    NotificacaoMostrarComponent,
    ConfiguracoesComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatCardModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatTableModule,
    MatDividerModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatDialogModule,
    FormsModule,
    NgbModule,
    NgxLoadingModule.forRoot({}),
    ModalModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 100,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      progressBar: true,
      closeButton: true,
      tapToDismiss: true,
      easeTime: 300,
      extendedTimeOut: 1000,
      progressAnimation: 'decreasing',
      easing: 'ease',
    }),
    NgxSpinnerModule,
    SharedModule,
    PainelAjudaModule,
    ChartsModule,
    KeycloakAngularModule,
  ],
  exports: [],
  providers: [
    EnvServiceProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializerKeyCloak,
      multi: true,
      deps: [KeycloakService, EnvService],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MatPaginatorIntl, useValue: getBrasilPaginatorIntl() },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL',
    },
    { provide: APP_BASE_HREF, useValue: '/meu-portal/' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
